import { useSelfHostedCurrentUser } from 'services/selfHosted'
import A from 'ui/A'
import Icon from 'ui/Icon'

function AdminLink() {
  const { data: user } = useSelfHostedCurrentUser({ suspense: false })

  if (!user?.isAdmin) {
    return null
  }

  return (
    <A variant="header" to={{ pageName: 'access' }}>
      <Icon size="md" name="cog" variant="solid" /> Admin
    </A>
  )
}

export default AdminLink
